// extracted by mini-css-extract-plugin
export default {"tag":"Tag_tag__7ieNh","small":"Tag_small__pS2LA"};